import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: "#71755e",
                primaryLight: "#a0a48b",
                primaryDark: "#464934",
                secondary: "#23272A",
                secondaryLight: "#4b4f52",
                secondaryDark: "#000000",
                accent: "#a89b8b"
            }
        }
    },
    icons: {
        iconfont: "mdi",
    },
});
